module.exports = __webpack_public_path__ + "static/media/takeaway.0cbd65d9.png";